// #338: the permalinks a card exposes — speaker, place, tag, year.
//
// All four point at the CALENDAR, never the map, even when the card is a map
// popup: "everything by this speaker" is a list, and a map filtered to one
// venue is a single pin.
//
// Each preserves the year you are currently on, so narrowing by speaker from
// inside /2026 keeps you in 2026 rather than silently dropping you back to
// upcoming. Pass `year = null` from a page with no year in its path (an event
// detail page, say) and the link lands on the default upcoming view.

import { urlForFilters, yearBounds } from './filterUrl.js'

function withYear(year, filters) {
  return year ? { ...filters, ...yearBounds(year) } : filters
}

export function speakerHref(userId, year = null) {
  if (userId == null) return null
  return urlForFilters('', withYear(year, { speakerId: String(userId) }))
}

// The city is the useful grain: country is too coarse to be interesting on a
// calendar this size, and a venue is one event. Returns null when the event
// has no city, so the caller renders plain text rather than a dead link.
export function placeHref(event, year = null) {
  const city = event?.city
  if (!city) return null
  return urlForFilters('', withYear(year, { city }))
}

export function tagHref(tag, year = null) {
  const slug = tag?.slug
  if (!slug) return null
  return urlForFilters('', withYear(year, { tag: slug }))
}

// The year an event falls in, as a link to that year's calendar. Derived from
// the event's own start rather than from the current route, so a card in the
// upcoming view still links somewhere meaningful.
//
// UTC, deliberately, even though the card renders the date in the viewer's
// local zone. The year view is a `from`/`to` window the API evaluates in UTC,
// so a talk at 2020-01-01T00:00:00Z belongs to 2020's window — and linking to
// the local year (2019 for anyone west of Greenwich) would land on a calendar
// that does not contain the event you just clicked. The two only disagree
// within hours of a year boundary, and landing somewhere real beats matching
// the rendered date to the hour.
export function yearHref(startsAtUtc) {
  if (!startsAtUtc) return null
  const year = new Date(startsAtUtc).getUTCFullYear()
  if (!Number.isFinite(year)) return null
  return urlForFilters('', yearBounds(year))
}
